const css = `.kpi-container .p-card-body {
  width: 100%;
}
.kpi-container .p-card-content {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  gap: 8px;
}
.kpi-container .kpi-value-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.kpi-container .kpi-value-container .kpi-title-container {
  --kpi-help-size: 14px;
  --kpi-help-gap: 8px;
}
.kpi-container .kpi-value-container .kpi-title-container > span:first-child:not(:last-child) {
  padding-right: calc(var(--kpi-help-gap) + var(--kpi-help-size));
}
.kpi-container .kpi-value-container .kpi-title-container .kpi-title-help {
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  width: var(--kpi-help-size);
  height: 1lh;
  margin-left: calc(-1 * var(--kpi-help-size));
}
.kpi-container span.bold {
  font-weight: var(--font-weight-bold);
  display: flex;
  gap: 8px;
}
.kpi-container div.previous {
  font-weight: var(--font-weight-medium);
  color: var(--text-subtle);
}
.kpi-container div.previous span:nth-child(1) {
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-semibold);
}
.kpi-container div.previous span:nth-child(2) {
  font-size: var(--font-size-xs);
}
.kpi-container div.previous.increase {
  color: var(--success);
}
.kpi-container div.previous.decrease {
  color: var(--danger);
}
.kpi-container .pi {
  border-radius: 8px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
